import React, { Fragment } from 'react'
import { FormSubmit, FormWrapper } from '@myxplor/forms'

import DownloadCSV, { fileNameWithDate } from '../../io/download-csv'
import { errorHandler as defaultErrorHandler } from '../../io/error-handling'

import ReportSuccess from './success'
import './reports.css'

const defaultOnSubmit = ({ remote_request, url, name }) => payload =>
  remote_request.submit({
    url,
    payload,
    fileName: fileNameWithDate(name),
  })

export const ReportForm = ({
  url,
  formOptions = {},
  name = 'Report',
  scoped = false,
  fieldsComponent,
  resetCurrentReport,
  successComponent = ReportSuccess,
  errorHandler = defaultErrorHandler,
  remote_request,
  onSubmit = defaultOnSubmit,
}) => {
  const { loading, success } = remote_request.state

  if (success) {
    return (
      <div className="reportForm--success">
        {React.createElement(successComponent, {
          resetCurrentReport,
          name,
        })}
      </div>
    )
  }

  const errors = errorHandler(remote_request.state)

  return (
    <FormWrapper
      {...formOptions}
      onSubmit={onSubmit({ remote_request, url, name })}
      render={formProps => (
        <Fragment>
          {fieldsComponent && (
            <div className="reportForm--fields">
              {React.createElement(fieldsComponent, {
                ...formProps,
                loading,
                errors,
                scoped,
              })}
            </div>
          )}

          <FormSubmit
            loading={loading}
            errors={errors.summary || errors.detail}
            disabled={!formProps.valid}
            loadingTitle={`Generating ${name}...`}>
            {`Generate ${name}`}
          </FormSubmit>
        </Fragment>
      )}
    />
  )
}

export default DownloadCSV(ReportForm)



// WEBPACK FOOTER //
// ./src/reports/views/form.jsx